<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-09-04 16:49:37
 * @FilePath: \mrc-ess-fronted\src\Layout\components\Progress.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-11-22 10:14:31
-->
<template>
  <v-progress-linear
    :active="isLoading"
    :background-opacity="0"
    :indeterminate="false"
    :value="value"
    top
    v-if="0"
    stream
    query
    height="5"
    absolute
    color="primary"
  ></v-progress-linear>
  <!-- v-if="0" 换回原来的peogress -->
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "MRC_Progress",
  computed: {
    ...mapGetters(["isLoading"]),
  },
  watch: {
    isLoading(val) {
      const that = this;
      if (val) {
        this.value = 25;
        this.inter = setInterval(() => {
          that.value = this.value + Math.random();
        }, 500);
      } else {
        this.value = 94;
        this.$Sleep(1500).then(() => {
          clearInterval(this.inter);
        });
      }
    },
    value(val) {
      if (val >= 95) {
        // clearInterval(this.inter);
        this.value = 95;
      }
    },
  },
  data() {
    return {
      inter: null,
      value: 0,
    };
  },
};
</script>